import { QuoteOrderDownloadButtonPDF, QuoteOrderDownloadPdfTemplateButton, QuoteOrderDuplicateButton, QuoteOrderVersionsSelector, QuoteOrderCommentsButton, QuoteOrderReopenButton, QuoteOrderShareButton, QuoteOrderButtonProps} from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderQuoteLayout/QuoteOrderButtons'
import { OrderData } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/types'
import { getBasePath } from '../../../../../../../../../../utils/globals/link'
import { useLocation } from 'react-router'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { SellDownloadButtonCSV, SellPdfPreview, SellQuickAccessButton } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellLayout/SellButtons'
import useEditDeleteModal from '../../../../../../../../../../utils/hooks/useEditDeleteModal'
import { Fragment, useMemo } from 'react'
import ModalProcessQuote from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderQuoteLayout/QuoteOrderButtons/ModalProcessQuote'
import { checkQuoteFromOrderAllOk } from '../../../../../../../../../../utils/globals/order/order'
import { ButtonPrimary } from '../../../../../../../../../../baseComponents/Button'
import { QuoteOrderStatusInversed } from '@teinor/erp/types/company/order/quote/quoteOrder'
import ModalSkipOperateStockOrder from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalSkipOperateStockOrder'
import { OrderStepButtonsBase, OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import { OrderStepButtonsDefaultBaseComponent, OrderStepButtonsNewStyleBaseComponent } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent'
import { OrderDivideIntoChaptersButton, OrderProductTypesButton, OrderVariablesButton } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtons'
import ModalOrderPaymentMethod from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalOrderPaymentMethod'

const QuoteOrderFinishedStepButtons: React.FC<OrderStepButtonsBaseComponentProps> = ({ data, onSubmit, ...rest }) => {
    const {t} = useTwinTranslation()
    const location = useLocation()
    const ShippingServiceId = data.header?.OrderShipping?.ShippingServiceId
    let infoMessageQuote = checkQuoteFromOrderAllOk(data, t)
    const showProcessButton = data?.header?.status === QuoteOrderStatusInversed['accepted']
    return (
        <div className='flex items-center relative gap-5 flex-wrap order_config_buttons_parent'>
            <OrderStepButtonsDefaultBaseComponent {...{ data, onSubmit, hookFunction: useQuoteOrderFinishedStepButtonsLogic, ...rest }} className={showProcessButton ? 'mr-8' : ''} />
            {showProcessButton ? <QuoteOrderProcessButton url={''} title={t('processQuote', 'Procesar presupuesto')} id='processQuote' disabled={false} infoMessage={infoMessageQuote || ''} data={data} {...{ ShippingServiceId, OrderId: data?.header?.id, orderStatus: QuoteOrderStatusInversed['processed'] }} /> : null}
            <div className='absolute top-9 right-0 order_version_selector'>
                <QuoteOrderVersionsSelector key='previousV' url={getBasePath(location.pathname, 'single')} versions={data?.header?.versions} currentValue={data?.header?.id} />
            </div>
        </div>
    )
}

const useQuoteOrderFinishedStepButtonsLogic = ({ data, onSubmit, isReadOnly }: OrderStepButtonsBaseComponentProps) => {
    const { t } = useTwinTranslation()
    const name = 'quote_order_finished_step_buttons'
    const Order = data?.header
    const OrderId = Order?.id
    const isLast = data?.header?.is_last
    const isPublicToken = data?.header?.publicToken
    const hideSellQuickAccesButton = !Order?.QuoteOrderId && !Order?.SellOrderId && !Order?.SellDeliveryNoteId && !Order?.SellInvoiceId && !Order?.WorkSheetId && !Order?.relatedSellOrders?.length && !Order?.relatedSellDeliveryNotes?.length && !Order?.relatedSellInvoices?.length && !Order?.relatedWorkSheets?.length

    const quoteOrderReopenText = t('ReopenQuote', 'Reabrir presupuesto')
    const quoteOrderShareText = t('ShareQuote', 'Compartir presupuesto')
    const quoteOrderUnshareText = t('quoteSharedInformation', 'Información sobre el presupuesto compartido')
    const quoteOrderCommentsText = t('conversationWithCustomer', 'Conversación con el cliente')
    const quoteOrderDuplicateText = t('duplicateQuote', 'Duplicar presupuesto')
    const sellDownloadCSVText = t('downloadCSV', 'Descargar CSV')
    const sellQuickAccessText = t('quickAccess', 'Acceso rápido')
    const sellPdfPreviewText = t('previewPdf', 'Previsualizar PDF')
    const quoteOrderDownloadPdfTemplateText = t('downloadSelectingPdfTemplate', 'Descargar seleccionando plantilla PDF')
    const quoteOrderDownloadButtonPDFText = t('downloadPdf', 'Descargar PDF')
    const quoteOrderDivideIntoChaptersText = t('divideIntoChapters', 'Dividir en capítulos')
    const quoteOrderVariablesText = t('variables', 'Variables')
    const quoteOrderProductTypesText = t('valueProductTypes', 'Valor tipos de producto')

   
    const defaultButtons = [{ "id": "previewQuote" }, { "id": "downloadQuote" }, { "id": "quoteOrderComments" }, { "id": "shareQuoteOrder" }, { "id": "duplicateQuoteOrder" }]

    const ButtonComponents: OrderStepButtonsBase = useMemo(() => {
        return {
            reopenQuoteOrder: {
                component: QuoteOrderReopenButton,
                showButton: isLast,
                extraProps: {
                    title: quoteOrderReopenText,
                    id: 'reopenQuoteOrder',
                    OrderId,
                    onSubmit
                }
            },
            shareQuoteOrder: {
                component: QuoteOrderShareButton,
                showButton: isLast || isPublicToken,
                extraProps: {
                    title: isPublicToken ? quoteOrderUnshareText : quoteOrderShareText,
                    id: 'shareQuoteOrder',
                    OrderId,
                    onSubmit,
                    allRowData: data
                }
            },
            quoteOrderComments: {
                component: QuoteOrderCommentsButton,
                extraProps: {
                    title: quoteOrderCommentsText,
                    id: 'quoteOrderComments',
                    onSubmit,
                    allRowData: data
                }
            },
            duplicateQuoteOrder: {
                component: QuoteOrderDuplicateButton,
                extraProps: {
                    id: 'duplicateQuoteOrder',
                    title: quoteOrderDuplicateText,
                    allRowData: data
                }
            },
            downloadQuoteCSV: {
                component: SellDownloadButtonCSV,
                extraProps: {
                    title: sellDownloadCSVText,
                    id: 'downloadQuoteCSV',
                    Order,
                    typeTemplate: 'quoteOrder'
                }
            },
            quickAccess: {
                component: SellQuickAccessButton,
                showButton: !hideSellQuickAccesButton,
                extraProps: {
                    id: 'quickAccess',
                    Order,
                    title: sellQuickAccessText
                }
            },
            previewQuote: {
                component: SellPdfPreview,
                extraProps: {
                    title: sellPdfPreviewText,
                    id: 'previewQuote',
                    Order,
                    typeTemplate: 'quoteOrder'
                }
            },
            downloadQuotePDFTemplate: {
                component: QuoteOrderDownloadPdfTemplateButton,
                extraProps: {
                    title: quoteOrderDownloadPdfTemplateText,
                    id: 'downloadQuotePDFTemplate',
                    Order
                }
            },
            downloadQuote: {
                component: QuoteOrderDownloadButtonPDF,
                extraProps: {
                    title: quoteOrderDownloadButtonPDFText,
                    id: 'downloadQuote',
                    Order
                }
            },
            divideIntoChaptersQuote: {
                component: OrderDivideIntoChaptersButton,
                extraProps: {
                    title: quoteOrderDivideIntoChaptersText,
                    id: 'divideIntoChaptersQuote',
                    allRowData: data,
                    isReadOnly,
                    onSubmit,
                }
            },
            variablesQuote: {
                component: OrderVariablesButton,
                extraProps: {
                    title: quoteOrderVariablesText,
                    id: 'variablesQuote',
                    allRowData: data,
                    isReadOnly,
                    onSubmit,
                }
            },
            quoteProductTypes: {
                component: OrderProductTypesButton,
                extraProps: {
                    title: quoteOrderProductTypesText,
                    id: 'quoteProductTypes',
                    allRowData: data,
                    onSubmit,
                    isReadOnly
                }
            },
        }
    }, [isLast, quoteOrderCommentsText, sellPdfPreviewText, quoteOrderDownloadButtonPDFText, quoteOrderDownloadPdfTemplateText, OrderId, data, onSubmit, quoteOrderShareText, quoteOrderUnshareText, isPublicToken, sellQuickAccessText, quoteOrderDuplicateText, Order, quoteOrderReopenText, sellDownloadCSVText, hideSellQuickAccesButton, quoteOrderDivideIntoChaptersText, quoteOrderVariablesText, isReadOnly, quoteOrderProductTypesText])

    return { ButtonComponents, name, defaultButtons }
}

export const QuoteOrderFinishedStepButtonsNew: React.FC<OrderStepButtonsBaseComponentProps> = ({ data, onSubmit, ...rest }) => {
    const { t } = useTwinTranslation()
    const location = useLocation()
    const ShippingServiceId = data.header?.OrderShipping?.ShippingServiceId
    let infoMessageQuote = checkQuoteFromOrderAllOk(data, t)
    const showProcessButton = data?.header?.status === QuoteOrderStatusInversed['accepted']
    return (
        <div className='flex order_config_buttons_parent items-center relative gap-5 flex-wrap'>
            <OrderStepButtonsNewStyleBaseComponent {...{ data, onSubmit, hookFunction: useQuoteOrderFinishedStepButtonsLogic, ...rest }} className={showProcessButton ? 'mr-8' : ''} />
            {showProcessButton ? <QuoteOrderProcessButton url={''} title={t('processQuote', 'Procesar presupuesto')} id='processQuote' disabled={false} infoMessage={infoMessageQuote || ''} data={data} {...{ ShippingServiceId, OrderId: data?.header?.id, orderStatus: QuoteOrderStatusInversed['processed'] }} /> : null}
            <div className='absolute top-9 right-0 order_version_selector'>
                <QuoteOrderVersionsSelector key='previousV' url={getBasePath(location.pathname, 'single')} versions={data?.header?.versions} currentValue={data?.header?.id} />
            </div>
        </div>
    )
}

interface QuoteOrderProcessButtonProps extends QuoteOrderButtonProps {
    data: OrderData
}
const QuoteOrderProcessButton: React.FC<QuoteOrderProcessButtonProps> = ({ id, title, disabled, OrderId, orderStatus, data }) => {
    const { openModal, setOpenModal } = useEditDeleteModal()
    return (
        <Fragment>
            <ButtonPrimary id={id + data?.header?.id} onClick={() => !disabled ? setOpenModal({ allRowData: { id: OrderId, status: orderStatus }, type: 'create' }) : undefined}>{title}</ButtonPrimary>
            {openModal?.type === 'create' ? <ModalProcessQuote setOpenModal={setOpenModal} data={data} OrderId={OrderId} /> : null}
            {openModal?.type === 'edit' ? <ModalSkipOperateStockOrder checkStockURLs={'/api/app/order/quote/checkAllQuoteOrderProductsStock'} setOpenModal={setOpenModal} allRowData={openModal.allRowData} finalizeOrder={openModal.allRowData.finalizeOrder} /> : null}
            {openModal?.type === 'delete' ? <ModalOrderPaymentMethod headerData={data.header} setOpened={() => setOpenModal(null)} allRowData={openModal.allRowData} totalsOrderTableData={openModal.allRowData?.totalsOrderTableData} beforeSubmit={openModal.allRowData.finalizeOrder} /> : null}
        </Fragment>
    )
}

export default QuoteOrderFinishedStepButtons